import {Card, CardContent, colors, Divider, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useEffect, useState} from 'react';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import {WCVDatePicker} from '../../../components/DateUtilsProvider/WCVDatePicker';
import moment from 'moment';
import {getHost} from '../../../graphql/GraphQlProvider';
import {RouteComponentProps} from "react-router-dom";
import useReactRouter from "use-react-router";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    divider: {
        backgroundColor: colors.grey[300]
    },
}));

const NetsuiteCsvDownload = () => {
    const { location }: RouteComponentProps<{ id: string }> = useReactRouter();
    const classes = useStyles();
    const title = 'Download CSV';
    const [selectedDate, setSelectedDate] = useState<string | null | undefined>(moment().subtract(1, 'days').format('YYYY-MM-DD'));
    const isGroups = location.pathname.includes('groups');

    useEffect(() => {
        if (selectedDate) {
            const url = getHost() + '/netsuite_csv/' + btoa(JSON.stringify({'date': selectedDate, 'isGroups': isGroups}));
            window.location.assign(url);
        }
    }, [selectedDate, isGroups]);

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="Netsuite" title={title}/>
            <Divider className={classes.divider}/>
            <Card>
                <CardContent>
                    <WCVDatePicker
                        id="available_from"
                        label="Select Day"
                        value={selectedDate}
                        onChange={(date, value) => {
                            setSelectedDate(value);
                        }}
                    />
                </CardContent>
            </Card>
        </Page>
    );
};

export default NetsuiteCsvDownload;
